module.exports = __webpack_public_path__ + "img/pentest-black.609c0e65.png";